export default {
    allAmericanTimezones: (state) => state.list,
    isNorthAmerican: (state) => (tzId) => state.list.includes(tzId),
    detectedTimezone: (state) => state.detectedTimezone,
};
